import { useState } from 'react'
import PropTypes from 'prop-types'
import { uniqBy } from 'lodash'
import { useTranslation } from 'react-i18next'

import { Select } from '@/components/ui/select'

import ConfirmPopup from '../../../Popups/ConfirmPopup'
import TextAreaField from '../../../FormLegacy/FormFieldsV2/TextAreaField'

const CancelMaintenanceRequestModal = ({
  yardiConfig,
  showModal,
  setShowModal,
  cancelMaintenanceRequest,
}) => {
  const { t } = useTranslation(['maintenance', 'common'])
  const [cancellationReason, setCancellationReason] = useState('')

  const isYardiProperty = yardiConfig != null
  const cancelReasons = (yardiConfig?.reasons ?? []).filter(
    (reason) => reason.attr?.['@_Status'] === 'Canceled',
  )
  const reasonOptions = uniqBy(cancelReasons, '#text')
  const hasOptions = reasonOptions.length > 0

  const shouldHideReasonLabel = isYardiProperty && !hasOptions

  const cancelConfirmInfo = () => (
    <div>
      <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 20 }}>
        {t('maintenance:requestPreview.cancelModal.confirmMessage')}
      </div>
      {!shouldHideReasonLabel && (
        <div style={{ fontWeight: 400, fontSize: 14, color: '#5C5C5C' }}>
          {t('maintenance:requestPreview.cancelModal.reasonPrompt')}
        </div>
      )}

      {isYardiProperty ? (
        <>
          {hasOptions && (
            <Select
              name={'cancellationReason'}
              placeholder={t('maintenance:requestPreview.cancelModal.reasonSelect.placeholder')}
              value={cancellationReason}
              onChange={(value) => setCancellationReason(value)}
              options={reasonOptions.map((reason) => ({
                value: reason['#text'],
                label: reason['#text'],
              }))}
            />
          )}
        </>
      ) : (
        <TextAreaField
          name={'cancellationReason'}
          placeholder={t('maintenance:requestPreview.cancelModal.reason.placeholder')}
          value={cancellationReason}
          onChange={(e) => setCancellationReason(e.target.value)}
          maxLength="500"
          style={{ width: '100%' }}
        />
      )}
    </div>
  )

  return (
    <ConfirmPopup
      title={t('maintenance:requestPreview.cancelModal.confirmationTitle')}
      body={cancelConfirmInfo()}
      cancelText={t('common:actions.cancel')}
      confirmText={t('common:actions.confirm')}
      isOpen={showModal}
      cancelCallback={() => setShowModal(false)}
      confirmCallback={() => {
        cancelMaintenanceRequest(cancellationReason)
      }}
      // TODO: this is temporal fix to be able to render `Select`'s dropdown options with correct z-index fighting
      // it will be someday refactored to new components but as quick resolution it works for now like this
      style={{ zIndex: '29' }}
    />
  )
}

CancelMaintenanceRequestModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  cancelMaintenanceRequest: PropTypes.func,
  yardiConfig: PropTypes.object,
}

export default CancelMaintenanceRequestModal
